<div class="container-fluid pb-5">
  <div class="d-flex align-items-center mb-2">
    <button *ngIf="tenant != 'wylo'"
      mat-icon-button
      class="mr-2"
      [routerLink]="RouteConstants.SalesOrder.SalesOrder.Route"
      [queryParams]="RouteConstants.SalesOrder.SalesOrder.QueryParams"
    >
      <span class="material-icons"> arrow_back </span>
    </button>

    <!-- For Wylo -->
    <button  *ngIf="tenant == 'wylo'"
      mat-icon-button
      class="mr-2"
      [routerLink]="RouteConstants.Visits.UsersMedications.Route+'/'+vid"
    >
    <span class="material-icons"> arrow_back </span>
  </button>
    <h4 class="main-heading mb-0">Create New Order</h4>
  </div>

  <div class="row">
    <div class="col-md-12" #noteRef>
      <div class="card shadow-sm">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <mat-tab-group #mtg (selectedIndexChange)="onTabChanged($event)" class="create-order-tab">
                <mat-tab label="Chronic" [disabled]="progress_spinner" *ngIf="!IsQuebec && tenant != 'wylo'">
                  <div class="acute">
                    <div
                      class="row align-items-center py-3"
                    >
                      <div class="col-md-4">
                        <form
                          [formGroup]="searchForm"
                          class="position-relative"
                        >
                          <div class="search">
                            <img
                              src="assets/images/icons/dashboard_search_icon.png"
                              alt="serch icon"
                              class="search-icon"
                            />
                            <input
                              type="text"
                              class="form-control w-100 marginl"
                              formControlName="search"
                              placeholder="Search by ID, name, Rx ID, Kroll ID"
                            />
                          </div>
                        </form>
                      </div>
                      <div class="col-md-4">
                         <div class="d-flex flex-shrink-0">
                          <mat-form-field class="w-100">
                            <mat-select
                            [formControl]="nursingHomeItems"
                            class="form-control"
                            placeholder="Select the Nursing Homes"
                          >
                            <mat-option
                              *ngFor="let homes of nursingHomes"
                              [value]="homes.ID"
                            >
                              {{ homes.Name }}
                            </mat-option>
                          </mat-select>
                           </mat-form-field>
                          <button
                            class="custom-btn"
                            (click)="onNursingHomeSubmit()"
                            [disabled]="isRxSubmitLoading || progress_spinner"
                          >
                            {{ isRxSubmitLoading ? 'Submitting...' : 'Submit' }}
                          </button>
                         </div>
                      </div>
                      <div class="col-md-4">
                        <mat-form-field class="w-100">
                        <mat-select
                          class="form-control matselect"
                          placeholder="Choose Delivery Partner"
                          [formControl]="formService.addDeliveryPartner"
                          (ngModelChange)="
                            checkCanadaPost(
                              formService.addDeliveryPartner.value
                            )
                          "
                        >
                          <mat-option
                            *ngFor="let item of deliveryPartners"
                            [value]="item.id"
                          >
                            {{ item.name }}
                          </mat-option>
                          <mat-option
                            class="select-btn"
                            (click)="
                              modalService.openAddDeliveryPartnerDialog(
                                this.deliveryPartners
                              )
                            "
                          >
                            <div class="d-flex align-items-center">
                              <span class="material-icons mr-2"> add </span>
                              add new delivery partner
                            </div>
                          </mat-option>
                        </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="acute-content">
                      <ng-template #noChronicData>
                        <div
                          class="d-flex flex-column align-items-center w-100 justify-content-center noAcuteDataFound"
                        >
                          <img
                            src="assets/images/emptystate.png"
                            alt="no data found icon"
                            class="mb-3"
                          />
                          <div class="bold">No New Order</div>
                        </div>
                      </ng-template>
                      <ng-container
                        *ngIf="chronicDataFound; else noChronicData"
                      >
                        <div class="acuteDataFound">
                          <div
                            class="w-100 h-100 d-flex align-items-center justify-content-center loader"
                            *ngIf="progress_spinner"
                          >
                            <span class="purpleLoader"></span>
                          </div>
                          <div
                            class="pagination-table"
                            *ngIf="!progress_spinner"
                          >
                            <table class="table" aria-describedby="Order Table">
                              <thead>
                                <tr>
                                  <th
                                    class="d-flex align-items-center left-aligned"
                                  >
                                    <div class="mr-2">
                                      <mat-checkbox
                                        class="example-margin"
                                        [checked]="isAllChecked"
                                        [indeterminate]="indeterminateChecked"
                                        (change)="
                                          setAllOrderSelected($event.checked)
                                        "
                                      >
                                      </mat-checkbox>
                                    </div>
                                    <div>
                                        <mat-form-field>
                                          <mat-select>
                                            <mat-option
                                              (click)="setAllOrderSelected(true)"
                                            >
                                              All
                                            </mat-option>
                                            <mat-option
                                              (click)="deleteSalesOrders()"
                                              [disabled]="
                                                selectedPaitents[
                                                  PatientType.Chronic
                                                ].length < 1
                                              "
                                            >
                                              <div
                                                class="d-flex align-items-center"
                                              >
                                                <img
                                                  src="assets/images/random_assets/delete.png"
                                                  alt="delete icon"
                                                  class="mr-2"
                                                />
                                                Delete
                                              </div>
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                    </div>
                                  </th>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'OrderID',
                                        value: 'Order ID'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'SalesOrderStatus',
                                        value: 'Status'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'FirstName',
                                        value: 'Name'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'RXIds',
                                        value: 'Rx Detail'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'RXIds',
                                        value: 'Acute RX ID'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'KrollID',
                                        value: 'Kroll Id'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'acuteRxId',
                                        value: 'Shipping Address'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'Packaging',
                                        value: 'Packaging'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'PackagingCost',
                                        value: 'Packaging cost'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngIf="isDeliveryCostColumnShow"
                                  >
                                    <ng-container
                                      *ngTemplateOutlet="
                                        th;
                                        context: {
                                          key: 'DeliveryCost',
                                          value: 'Delivery cost'
                                        }
                                      "
                                    >
                                    </ng-container>
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'TotalMedCost',
                                        value: 'Total Med Cost'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'PaymentDue',
                                        value: 'Payment Due'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'created_by',
                                        value: 'Created By'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'deliveryPartners',
                                        value: 'Delivery Partner'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <!-- discover service start-->
                                  <ng-container >
                                    <ng-container
                                      *ngTemplateOutlet="
                                        th;
                                        context: {
                                          key: 'discoverService',
                                          value: 'Service/Delivery Date'
                                        }
                                      "
                                    >
                                    </ng-container>
                                  </ng-container>
                                  <ng-container>
                                    <ng-container
                                      *ngTemplateOutlet="
                                        th;
                                        context: {
                                          key: 'option',
                                          value: 'Option/Tags'
                                        }
                                      "
                                    >
                                    </ng-container>
                                  </ng-container>
                                  <!-- discover service end-->
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'Action',
                                        value: 'Action'
                                      }
                                    "
                                  >
                                  </ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: { key: 'Ship', value: 'Ship' }
                                    "
                                  >
                                  </ng-container>
                                </tr>
                              </thead>

                              <tbody>
                                <tr
                                  *ngFor="
                                    let item of response.list
                                      | orderBy
                                        : paginationObj.sort_key
                                        : (paginationObj.sort_type ==
                                          SortType.Ascending
                                            ? true
                                            : false)
                                      | paginate : config;
                                    let i = index
                                  "
                                >
                                  <td class="left-aligned">
                                    <mat-checkbox
                                      class="example-margin"
                                      (change)="onCheckChange($event, item)"
                                      [checked]="isChecked(item)"
                                    >
                                    </mat-checkbox>
                                  </td>
                                  <td>{{ item.OrderID }}</td>
                                  <td class="status">
                                    {{ item.SalesOrderStatus }}
                                  </td>
                                  <td>
                                    <a class="text-black mt-2 mt-md-0 cursor-pointer"
                                      (click)="navigateToPatientProfile(item.UserID)">
                                      {{ item.FirstName }} {{ item.LastName }}
                                      {{ item.ManageBy }}
                                    </a>
                                  </td>
                                  <td>
                                    <mat-chip-set class="nowrap" #chipList>
                                      <mat-chip
                                        *ngFor="let val of item.RXIds"
                                        [removable]="removable"
                                        (removed)="remove(val)"
                                      >
                                        {{ val }}
                                      </mat-chip>
                                      <button
                                        mat-icon-button
                                        (click)="
                                          modalService.openDialog(
                                            item,
                                            paginationObj.shipping_type
                                          )
                                        "
                                      >
                                        <mat-icon>more_vert</mat-icon>
                                      </button>
                                    </mat-chip-set>
                                  </td>
                                  <td>
                                    {{ item.acuteRxId }}
                                    <div class="d-flex align-items-center">
                                      <div
                                        *ngIf="
                                          item.acuteRXID.isAcuteRXInputShow
                                        "
                                        class="row container-fluid"
                                        id="divshow"
                                      >
                                        <div
                                          class="col d-flex align-items-center my-md-0 my-2"
                                        >
                                          <div
                                            class="form-control"
                                            style="width: 300px"
                                          >
                                            <mat-chip-set #chipList>
                                              <mat-chip
                                                *ngFor="
                                                  let val of item.acuteRXID
                                                    .rxIds
                                                "
                                                [removable]="removable"
                                                (removed)="
                                                  removeRxId(val, item)
                                                "
                                              >
                                                {{ val }}
                                                <mat-icon
                                                  matChipRemove
                                                  *ngIf="removable"
                                                >
                                                  <img
                                                    src="assets/images/icons/cross_icon.png"
                                                    alt="remove-chip icon"
                                                    class="remove-chip-btn"
                                                  />
                                                </mat-icon>
                                              </mat-chip>
                                              <!-- <input class="form-control-chip" style="width: 80px" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                                [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRxId($event, item)" placeholder="Enter Rx ID"/> -->

                                                <input class="form-control-chip" style="width: 80px" placeholder="Enter Rx ID"/>
                                            </mat-chip-set>
                                            <div
                                              class="error-message text-danger"
                                              *ngIf="item.acuteRXID.error"
                                            >
                                              {{ item.acuteRXID.error }}
                                            </div>
                                          </div>
                                          <button
                                            mat-icon-button
                                            (click)="
                                              getPatientOrderByAcuteIds(item)
                                            "
                                          >
                                            <img
                                              src="assets/images/random_assets/next.png"
                                              alt="next icon"
                                              *ngIf="
                                                !item.acuteRXID.isLoading;
                                                else loaderShow
                                              "
                                            />
                                            <ng-template #loaderShow>
                                              <span class="whiteLoader"
                                                >&nbsp;</span
                                              >
                                            </ng-template>
                                          </button>
                                        </div>
                                      </div>
                                      <button
                                        mat-icon-button
                                        (click)="
                                          item.acuteRXID.isAcuteRXInputShow =
                                            !item.acuteRXID.isAcuteRXInputShow
                                        "
                                      >
                                        <img
                                          src="assets/images/random_assets/add_field.png"
                                          *ngIf="
                                            !item.acuteRXID.isAcuteRXInputShow
                                          "
                                          alt="add_field icon"
                                        />
                                        <img
                                          src="assets/images/random_assets/cross_grey.png"
                                          alt="cross icon"
                                          *ngIf="
                                            item.acuteRXID.isAcuteRXInputShow
                                          "
                                        />
                                      </button>
                                    </div>
                                  </td>
                                  <td>{{ item.KrollID }}</td>
                                  <td class="address">
                                    {{ item.Address1 }} {{ item.City }}
                                    {{ item.Prov }} {{ item.Postal }}
                                    {{ item.Country }}
                                    {{
                                      item.Address2 == "DO NOT SHIP"
                                        ? ""
                                        : item.Address2
                                    }}
                                  </td>
                                  <td
                                    class="openDialog"
                                    (click)="openPackagingDialog(item)"
                                  >
                                    {{ item.Packaging }}
                                  </td>
                                  <td class="packagingCost">
                                    {{ item.PackagingCost }}
                                  </td>
                                  <td
                                    class="packagingCost"
                                    *ngIf="isDeliveryCostColumnShow"
                                  >
                                    {{
                                      item.DeliveryCost
                                        ? item.DeliveryCost
                                        : "0"
                                    }}
                                  </td>
                                  <td
                                    class="openDialog"
                                    (click)="
                                      modalService.openMedCostDialog(
                                        item,
                                        paginationObj.shipping_type
                                      )
                                    "
                                  >
                                    {{ item.TotalMedCost | number : ".1-2" }}
                                  </td>
                                  <td class="openDialog">
                                    <span
                                      (click)="
                                        modalService.openPaymentPlanDialog(
                                          item,
                                          paginationObj.shipping_type
                                        )
                                      "
                                    >
                                      {{ item.PaymentDue | number : ".1-2" }}
                                    </span>
                                    <mat-checkbox
                                      class="example-margin ml-2"
                                      [(ngModel)]="item.IsAutoPay"
                                      [hidden]="
                                        (item.PaymentDue && !item.CardExit) ||
                                        item.PaymentDue == 0
                                      "
                                    >
                                    </mat-checkbox>
                                    <div
                                      class="ac_applied"
                                      *ngIf="
                                        item?.orderSummery
                                          ?.addCoverageAmount !== undefined &&
                                        item?.orderSummery?.addCoverageAmount >
                                          0
                                      "
                                    >
                                      <span> AC applied</span>
                                      <button
                                        *ngIf="
                                          item?.rxNumMsg !== undefined &&
                                          item?.rxNumMsg !== ''
                                        "
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Remove additional coverage"
                                        (click)="removeAcApplied(item)"
                                        color="delete-record"
                                        mat-icon-button
                                      >
                                        <mat-icon class="delete-record"
                                          >delete_forever</mat-icon
                                        >
                                      </button>
                                    </div>
                                  </td>
                                  <td class="packagingCost">
                                    {{
                                      item.created_by
                                        ? item.created_by.display_name
                                        : "-"
                                    }}
                                    {{
                                      item.created_at
                                        ? helperService.getDate(item.created_at)
                                        : ""
                                    }}
                                    {{
                                      item.created_at
                                        ? helperService.getTime(item.created_at)
                                        : ""
                                    }}
                                  </td>
                                  <td class="deliveryPartner">
                                    <mat-select
                                      style="width: 155px"
                                      class="form-control"
                                      placeholder="Delivery Partner"
                                      [(ngModel)]="item.DeliveryPartnerID"
                                      (selectionChange)="
                                        getDeliveryPartnerCanadaPost(
                                          item,
                                          $event
                                        )
                                      "
                                    >
                                      <mat-option
                                        *ngFor="let item of deliveryPartners"
                                        [value]="item.id"
                                      >
                                        {{ item.name }}
                                      </mat-option>
                                    </mat-select>
                                  </td>
                                 <!-- discover service start -->

                                  <!-- Service Section (Canada Post or MWS) -->
                                  <td class="deliveryPartner">
                                    <ng-container *ngIf="item.isShowCanadaPostOption; else showDatePicker">
                                      <!-- Canada Post: Service Dropdown -->
                                      <mat-form-field>
                                        <mat-select class="form-control" style="width: 155px" placeholder="Service"
                                          [(ngModel)]="item.ServiceCode" (click)="dropdownClicked(item)">
                                          <mat-option *ngFor="let items of item.discoverServiceList" [value]="items.ServiceCode">
                                            {{ items.ServiceName }} ({{ items?.PriceDetails?.base }})
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                    </ng-container>

                                    <!-- MWS: Date Picker -->
                                    <ng-template #showDatePicker>
                                      <ng-container *ngIf="item.isShowMWSPostOption; else showDash">
                                        <div class="position-relative">
                                          <input matInput [matDatepicker]="dobPicker" readonly [min]="getCurrentDate()"
                                            (dateChange)="onDateChange($event.value, item)" (click)="dobPicker.open()"
                                            class="form-control" placeholder="Enter date of delivery" [(ngModel)]="deliveryDates[item.ID]"
                                            style="width: 155px" />
                                          <mat-datepicker-toggle matSuffix [for]="dobPicker" class="date-icon"></mat-datepicker-toggle>
                                          <mat-datepicker #dobPicker></mat-datepicker>
                                        </div>
                                      </ng-container>
                                    </ng-template>

                                    <!-- Show Dash if No Partner Selected -->
                                    <ng-template #showDash>-</ng-template>
                                  </td>

                                  <!-- Options Section (Canada Post or MWS) -->
                                  <td class="deliveryPartner">
                                    <!-- Canada Post: Options Dropdown -->
                                    <ng-container *ngIf="item.isShowCanadaPostOption && !item.isShowMWSPostOption">
                                      <mat-form-field>
                                        <mat-select class="form-control" style="width: 155px" placeholder="Options"
                                          [(ngModel)]="item.OptionCode" [multiple]="true"
                                          (selectionChange)="autoSelectAndDisableEnableOption(item, $event)">
                                          <mat-option *ngFor="let items of optionList" [value]="items.OptionCode" [disabled]="items.disabled">
                                            {{ items.OptionName }}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                    </ng-container>

                                    <!-- MWS Post: Tag Option Dropdown -->
                                    <ng-container *ngIf="item.isShowMWSPostOption && !item.isShowCanadaPostOption">
                                      <mat-form-field>
                                        <mat-select class="form-control" style="width: 155px" placeholder="MWS Tags" [multiple]="true"
                                          (selectionChange)="mwsOptionFilter(item, $event)" [(ngModel)]="item.OptionCode">
                                          
                                          <!-- Order Options Group -->
                                          <mat-optgroup *ngIf="orderOptions?.length" label="Order">
                                            <mat-option *ngFor="let items of orderOptions" [value]="items?.info?.id"
                                              [disabled]="items.disabled" [matTooltip]="getTooltip(items?.info?.id)"
                                              [matTooltipPosition]="'left'" [matTooltipClass]="'custom-shipping-tooltip-class'">
                                              {{ items?.info?.label }}
                                            </mat-option>
                                          </mat-optgroup>

                                          <!-- Customer Options Group -->
                                          <!-- <mat-optgroup *ngIf="clientOptions?.length" label="Customer">
                                            <mat-option *ngFor="let items of clientOptions" [value]="items?.info?.id"
                                              [disabled]="items.disabled" [matTooltip]="getTooltip(items?.info?.id)"
                                              [matTooltipPosition]="'left'" [matTooltipClass]="'custom-shipping-tooltip-class'">
                                              {{ items?.info?.label }}
                                            </mat-option>
                                          </mat-optgroup> -->
                                        </mat-select>
                                      </mat-form-field>
                                    </ng-container>

                                    <!-- Show Dash if No Partner Selected -->
                                    <ng-container *ngIf="!item.isShowCanadaPostOption && !item.isShowMWSPostOption">
                                      -
                                    </ng-container>
                                  </td>

                                  <!-- discover service end-->
                                  <td class="d-flex align-items-center">
                                    <button
                                      matTooltip="pay with other"
                                      mat-icon-button
                                      class="mt10 me-1 openDialog"
                                      (click)="openWarningDialog(item)"
                                      [disabled]="item.PaymentDue == 0"
                                    >
                                      <img
                                        src="assets/images/random_assets/credit_card.png"
                                        alt="credit_card icon"
                                        class="invoice-icon"
                                        *ngIf="
                                          item.PayWith != 'other';
                                          else payWithOtherImg
                                        "
                                      />
                                      <ng-template #payWithOtherImg>
                                        <img
                                          src="assets/images/random_assets/pay_with_other_selected.png"
                                          class="invoice-icon"
                                          alt="pay with other method icon"
                                        />
                                      </ng-template>
                                    </button>

                                    <button
                                      matTooltip="Signature"
                                      mat-icon-button
                                      class="mt10 openDialog"
                                      (click)="
                                        item.SignatureRequired =
                                          !item.SignatureRequired
                                      "
                                      [disabled]="item?.DeliveryPartnerID == 9"
                                    >
                                      <img
                                        src="assets/images/random_assets/signature_required.png"
                                        alt="signature_required icon"
                                        class="invoice-icon"
                                        [ngClass]="{'disabled-sign-icon' : item?.DeliveryPartnerID == 9}"
                                        *ngIf="
                                          item.SignatureRequired;
                                          else noSignatureRequired
                                        "
                                      />
                                      <ng-template #noSignatureRequired>
                                        <img
                                          alt="signature_not_required icon"
                                          src="assets/images/random_assets/signature_not_required.png"
                                          class="invoice-icon"
                                          [ngClass]="{'disabled-sign-icon' : item?.DeliveryPartnerID == 9}"
                                        />
                                      </ng-template>
                                    </button>

                                    <button
                                      class="mt10 openDialog"
                                      mat-button
                                      [matMenuTriggerFor]="moreOpt"
                                    >
                                      <span class="material-icons-outlined"
                                        >more_vert
                                      </span>
                                    </button>
                                    <mat-menu #moreOpt="matMenu">
                                      <button
                                        mat-menu-item
                                        class="d-flex align-items-center"
                                        (click)="
                                          modalService.addDimentionWeightDialog(
                                            item
                                          )
                                        "
                                      >
                                        Dimension/Weight
                                      </button>
                                      <button
                                        mat-menu-item
                                        class="d-flex align-items-center"
                                        (click)="openPromoCode(item)"
                                      >
                                        Promo Code
                                      </button>
                                    </mat-menu>
                                  </td>
                                  <td>
                                    <mat-slide-toggle
                                      color="primary"
                                      [checked]="ship(item)"
                                      (change)="shipChange($event, item)"
                                    >
                                    </mat-slide-toggle>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <app-pagination
                          [config]="config"
                          (pageChange)="pageChange($event)"
                          id="server"
                          *ngIf="!progress_spinner"
                        >
                        </app-pagination>
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-md-12">
                              <div
                                class="d-flex justify-content-center justify-content-md-end border-top pt-4"
                              >
                                <button
                                  class="custom-btn"
                                  type="button"
                                  (click)="openProcessPaymentDialog()"
                                  [disabled]="!isProcessPaymentEnable"
                                >
                                  Process Payment
                                </button>
                                <button
                                  class="custom-btn"
                                  type="button"
                                  [disabled]="isCheckRateEnable"
                                  (click)="onCheckRateClick()"
                                >
                                  Check Rate
                                  <span
                                    class="whiteLoader"
                                    *ngIf="isCheckRateLoading"
                                    >&nbsp;</span
                                  >
                                </button>
                                <button
                                  class="custom-btn"
                                  (click)="openProcessOrderModel()"
                                  type="button"
                                  [disabled]="!isProcessOrderEnable || isProcessOrderLoading"
                                >
                                  Process Order
                                  <span
                                    class="whiteLoader"
                                    *ngIf="isProcessOrderLoading"
                                    >&nbsp;</span
                                  >
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab [label]="(tenant != 'wylo') ? 'Acute' : 'Order'" [disabled]="progress_spinner" *ngIf="!IsQuebec">
                  <div class="acute">
                    <div class="row align-items-center py-3">
                      <div class="col-md-4" *ngIf="tenant != 'wylo'">
                        <form [formGroup]="searchForm" class="position-relative">
                          <div class="search">
                            <img src="assets/images/icons/dashboard_search_icon.png" alt="search icon" class="search-icon"/>
                            <input type="text" class="form-control w-100 marginl" formControlName="search" placeholder="Search by ID, name, Rx ID, Kroll ID"/>
                          </div>
                        </form>
                      </div>
                      <div class="col">
                        <div class="d-flex flex-shrink-0">
                          <mat-chip-grid #chipList aria-label="Fruit selection" class="w-100 form-control" placeholder="Enter Rx ID">
                            <mat-chip-row *ngFor="let val of paginationObj.search_value" [removable]="removable" (removed)="remove(val)">
                              {{ val }}
                              <mat-icon matChipRemove *ngIf="removable">
                                <img src="assets/images/icons/cross_icon.png" alt="remove-chip icon" class="remove-chip-btn"/>
                              </mat-icon>
                            </mat-chip-row>
                            <input class="form-control-chip form-control"
                            [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="add($event)"
                            placeholder="Enter Rx ID"/>
                          </mat-chip-grid>

                        <button class="custom-btn" (click)="rxIdSubmit()" [disabled]="isRxSubmitLoading || progress_spinner">
                          {{ isRxSubmitLoading ? 'Submitting...' : 'Submit' }}
                        </button>
                      </div>
                  </div>
                      <div class="col-md-4 col">
                         <mat-form-field>
                          <mat-select
                          class="form-control matselect"
                          placeholder="Choose Delivery Partner"
                          [formControl]="formService.addDeliveryPartner"
                          (ngModelChange)="
                            checkCanadaPost(
                              formService.addDeliveryPartner.value
                            )
                          "
                        >
                          <mat-option
                            *ngFor="let item of deliveryPartners"
                            [value]="item.id"
                          >
                            {{ item.name }}
                          </mat-option>
                          <mat-option
                            class="select-btn"
                            (click)="
                              modalService.openAddDeliveryPartnerDialog(
                                this.deliveryPartners
                              )
                            "
                          >
                            <div class="d-flex align-items-center">
                              <span class="material-icons mr-2"> add </span>
                              add new delivery partner
                            </div>
                          </mat-option>
                        </mat-select>
                         </mat-form-field>
                      </div>
                    </div>
                    <div class="acute-content">
                      <ng-template #noAcuteData>
                        <div
                          class="d-flex flex-column align-items-center w-100 justify-content-center noAcuteDataFound"
                        >
                          <img
                            src="assets/images/emptystate.png"
                            alt="no data found icon"
                            class="mb-3"
                          />
                          <div class="semibold mb-1">No New Order</div>
                        </div>
                      </ng-template>
                      <ng-container *ngIf="acuteDataFound; else noAcuteData">
                        <div class="acuteDataFound">
                          <div
                            class="w-100 h-100 d-flex align-items-center justify-content-center loader"
                            *ngIf="progress_spinner"
                          >
                            <span class="purpleLoader"></span>
                          </div>
                          <table
                            class="table"
                            aria-describedby="Acute table"
                            *ngIf="!progress_spinner"
                          >
                            <thead>
                              <tr>
                                <th
                                  class="d-flex align-items-center left-aligned"
                                >
                                  <div class="mr-2">
                                    <mat-checkbox
                                      class="example-margin"
                                      [checked]="isAllChecked"
                                      [indeterminate]="indeterminateChecked"
                                      (change)="
                                        setAllOrderSelected($event.checked)
                                      "
                                    >
                                    </mat-checkbox>
                                  </div>
                                  <div>
                                    <mat-select>
                                      <mat-option
                                        (click)="setAllOrderSelected(true)"
                                      >
                                        All
                                      </mat-option>
                                      <mat-option
                                        (click)="deleteSalesOrders()"
                                        [disabled]="
                                          selectedPaitents[PatientType.Acute]
                                            .length < 1
                                        "
                                      >
                                        <div class="d-flex align-items-center">
                                          <img
                                            src="assets/images/random_assets/delete.png"
                                            alt="delete icon"
                                            class="mr-2"
                                          />
                                          Delete
                                        </div>
                                      </mat-option>
                                    </mat-select>
                                  </div>
                                </th>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: {
                                      key: 'OrderID',
                                      value: 'Order ID'
                                    }
                                  "
                                >
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: {
                                      key: 'SalesOrderStatus',
                                      value: 'Status'
                                    }
                                  "
                                >
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: { key: 'FirstName', value: 'Name' }
                                  "
                                >
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: {
                                      key: 'RXIds',
                                      value: 'Rx Detail'
                                    }
                                  "
                                >
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: {
                                      key: 'KrollID',
                                      value: 'Kroll Id'
                                    }
                                  "
                                >
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: {
                                      key: 'Address1',
                                      value: 'Shipping Address'
                                    }
                                  "
                                >
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: {
                                      key: 'Packaging',
                                      value: 'Packaging'
                                    }
                                  "
                                >
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: {
                                      key: 'PackagingCost',
                                      value: 'Packaging cost'
                                    }
                                  "
                                >
                                </ng-container>
                                <ng-container *ngIf="isDeliveryCostColumnShow">
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'DeliveryCost',
                                        value: 'Delivery cost'
                                      }
                                    "
                                  >
                                  </ng-container>
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: {
                                      key: 'TotalMedCost',
                                      value: 'Total Med Cost'
                                    }
                                  "
                                >
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: {
                                      key: 'PaymentDue',
                                      value: 'Payment Due'
                                    }
                                  "
                                >
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: {
                                      key: 'deliveryPartners',
                                      value: 'Delivery Partner'
                                    }
                                  "
                                >
                                </ng-container>

                                <!-- discover service start-->
                                <ng-container>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'discoverService',
                                        value: 'Service/Delivery Date'
                                      }
                                    "
                                  >
                                  </ng-container>
                                </ng-container>
                                <ng-container >
                                  <ng-container
                                    *ngTemplateOutlet="
                                      th;
                                      context: {
                                        key: 'option',
                                        value: 'Option/Tags'
                                      }
                                    "
                                  >
                                  </ng-container>
                                </ng-container>
                                <!-- discover service end-->

                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: { key: 'Action', value: 'Action' }
                                  "
                                >
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="
                                    th;
                                    context: { key: 'Ship', value: 'Ship' }
                                  "
                                >
                                </ng-container>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                *ngFor="
                                  let item of response.list
                                    | orderBy
                                      : paginationObj.sort_key
                                      : (paginationObj.sort_type ==
                                        SortType.Ascending
                                          ? true
                                          : false)
                                    | paginate : config;
                                  let i = index
                                "
                              >
                                <td class="left-aligned">
                                  <mat-checkbox
                                    class="example-margin"
                                    (change)="onCheckChange($event, item)"
                                    [checked]="isChecked(item)"
                                  ></mat-checkbox>
                                </td>
                                <td>{{ item?.OrderID }}</td>
                                <td class="status">
                                  {{ item?.SalesOrderStatus }}
                                </td>
                                <td>
                                    <a class="text-black mt-2 mt-md-0 cursor-pointer"
                                      (click)="navigateToPatientProfile(item.UserID)">
                                      {{ item.FirstName }} {{ item.LastName }}
                                      {{ item.ManageBy }}
                                    </a>
                                  </td>
                                <td>
                                  <mat-chip-set class="nowrap" #chipList>
                                    <mat-chip
                                      *ngFor="let val of item?.RXIds"
                                      [removable]="removable"
                                      (removed)="remove(val)"
                                    >
                                      {{ val }}
                                    </mat-chip>
                                    <button
                                      mat-icon-button
                                      (click)="
                                        modalService.openDialog(
                                          item,
                                          paginationObj.shipping_type
                                        )
                                      "
                                    >
                                      <mat-icon>more_vert</mat-icon>
                                    </button>
                                  </mat-chip-set>
                                </td>
                                <td>{{ item?.KrollID }}</td>
                                <td class="address">
                                  {{ item?.Address1 }} {{ item?.City }}
                                  {{ item?.Prov }} {{ item?.Postal }}
                                  {{ item?.Country }}
                                  {{
                                    item?.Address2 == "DO NOT SHIP"
                                      ? ""
                                      : item?.Address2
                                  }}
                                </td>
                                <td
                                  class="openDialog"
                                  (click)="openPackagingDialog(item)"
                                >
                                  {{ item?.Packaging }}
                                </td>
                                <td class="packagingCost">
                                  {{ item?.PackagingCost }}
                                </td>
                                <td
                                  class="packagingCost"
                                  *ngIf="isDeliveryCostColumnShow"
                                >
                                  {{
                                    item?.DeliveryCost ? item?.DeliveryCost : "0"
                                  }}
                                </td>
                                <td
                                  class="openDialog"
                                  (click)="
                                    modalService.openMedCostDialog(
                                      item,
                                      paginationObj.shipping_type
                                    )
                                  "
                                >
                                  {{ item?.TotalMedCost | number : ".1-2" }}
                                </td>
                                <td class="openDialog">
                                  <span
                                    (click)="
                                      modalService.openPaymentPlanDialog(
                                        item,
                                        paginationObj.shipping_type
                                      )
                                    "
                                  >
                                    {{ item?.PaymentDue | number : ".1-2" }}
                                  </span>
                                  <mat-checkbox
                                    class="example-margin ml-2 check_right"
                                    [(ngModel)]="item.IsAutoPay"
                                    [hidden]="
                                      (item?.PaymentDue && !item?.CardExit) ||
                                      item?.PaymentDue == 0
                                    "
                                  >
                                  </mat-checkbox>
                                  <div
                                    class="ac_applied"
                                    *ngIf="
                                      item?.orderSummery?.addCoverageAmount !==
                                        undefined &&
                                      item?.orderSummery?.addCoverageAmount > 0
                                    "
                                  >
                                    <span> AC applied</span>
                                    <button
                                      *ngIf="
                                        item?.rxNumMsg !== undefined &&
                                        item?.rxNumMsg !== ''
                                      "
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title="Remove additional coverage"
                                      (click)="removeAcApplied(item)"
                                      color="delete-record"
                                      mat-icon-button
                                    >
                                      <mat-icon class="delete-record"
                                        >delete_forever</mat-icon
                                      >
                                    </button>
                                  </div>
                                </td>
                                <td class="deliveryPartner">
                                  <mat-select
                                    style="width: 155px"
                                    class="form-control"
                                    placeholder="Delivery Partner"
                                    [(ngModel)]="item.DeliveryPartnerID"
                                    (selectionChange)="
                                      getDeliveryPartnerCanadaPost(item, $event)
                                    "
                                  >
                                    <mat-option
                                      *ngFor="let item of deliveryPartners"
                                      [value]="item?.id"
                                    >
                                      {{ item?.name }}
                                    </mat-option>
                                  </mat-select>
                                </td>

                                <!-- discover service start-->

                                  <!-- Service Section (Canada Post or MWS) -->
                                  <td class="deliveryPartner">
                                    <ng-container *ngIf="item.isShowCanadaPostOption; else showDatePicker">
                                      <!-- Canada Post: Service Dropdown -->
                                      <mat-form-field>
                                        <mat-select class="form-control" style="width: 155px" placeholder="Service"
                                          [(ngModel)]="item.ServiceCode" (click)="dropdownClicked(item)">
                                          <mat-option *ngFor="let items of item.discoverServiceList" [value]="items.ServiceCode">
                                            {{ items.ServiceName }} ({{ items?.PriceDetails?.base }})
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                    </ng-container>

                                    <!-- MWS: Date Picker -->
                                    <ng-template #showDatePicker>
                                      <ng-container *ngIf="item.isShowMWSPostOption; else showDash">
                                        <div class="position-relative">
                                          <input matInput [matDatepicker]="dobPicker1" readonly [min]="getCurrentDate()"
                                            (dateChange)="onDateChange($event.value, item)" (click)="dobPicker1.open()"
                                            class="form-control" placeholder="Enter date of delivery" [(ngModel)]="deliveryDates[item.ID]"
                                            style="width: 155px" />
                                          <mat-datepicker-toggle matSuffix [for]="dobPicker1" class="date-icon"></mat-datepicker-toggle>
                                          <mat-datepicker #dobPicker1></mat-datepicker>
                                        </div>
                                      </ng-container>
                                    </ng-template>

                                    <!-- Show Dash if No Partner Selected -->
                                    <ng-template #showDash>-</ng-template>
                                  </td>

                                  <!-- Options Section (Canada Post or MWS) -->
                                  <td class="deliveryPartner">
                                    <!-- Canada Post: Options Dropdown -->
                                    <ng-container *ngIf="item.isShowCanadaPostOption && !item.isShowMWSPostOption">
                                      <mat-form-field>
                                        <mat-select class="form-control" style="width: 155px" placeholder="Options"
                                          [(ngModel)]="item.OptionCode" [multiple]="true"
                                          (selectionChange)="autoSelectAndDisableEnableOption(item, $event)">
                                          <mat-option *ngFor="let items of optionList" [value]="items.OptionCode" [disabled]="items.disabled">
                                            {{ items.OptionName }}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                    </ng-container>

                                    <!-- MWS Post: Tag Option Dropdown -->
                                    <ng-container *ngIf="item.isShowMWSPostOption && !item.isShowCanadaPostOption">
                                      <mat-form-field>
                                        <mat-select class="form-control" style="width: 155px" placeholder="MWS Tags" [multiple]="true"
                                          (selectionChange)="mwsOptionFilter(item, $event)" [(ngModel)]="item.OptionCode">
                                          
                                          <!-- Order Options Group -->
                                          <mat-optgroup *ngIf="orderOptions?.length" label="Order">
                                            <mat-option *ngFor="let items of orderOptions" [value]="items?.info?.id"
                                              [disabled]="items.disabled" [matTooltip]="getTooltip(items?.info?.id)"
                                              [matTooltipPosition]="'left'" [matTooltipClass]="'custom-shipping-tooltip-class'">
                                              {{ items?.info?.label }}
                                            </mat-option>
                                          </mat-optgroup>

                                          <!-- Customer Options Group -->
                                          <!-- <mat-optgroup *ngIf="clientOptions?.length" label="Customer">
                                            <mat-option *ngFor="let items of clientOptions" [value]="items?.info?.id"
                                              [disabled]="items.disabled" [matTooltip]="getTooltip(items?.info?.id)"
                                              [matTooltipPosition]="'left'" [matTooltipClass]="'custom-shipping-tooltip-class'">
                                              {{ items?.info?.label }}
                                            </mat-option>
                                          </mat-optgroup> -->
                                        </mat-select>
                                      </mat-form-field>
                                    </ng-container>

                                    <!-- Show Dash if No Partner Selected -->
                                    <ng-container *ngIf="!item.isShowCanadaPostOption && !item.isShowMWSPostOption">
                                      -
                                    </ng-container>
                                  </td>

                                  <!-- discover service end -->

                                <td class="d-flex align-items-center">
                                  <button
                                    matTooltip="pay with other"
                                    mat-icon-button
                                    class="mt10 me-1 openDialog"
                                    (click)="openWarningDialog(item)"
                                    [disabled]="item?.PaymentDue == 0"
                                  >
                                    <img
                                      src="assets/images/random_assets/credit_card.png"
                                      alt="credit card icon"
                                      class="invoice-icon"
                                      *ngIf="
                                        item?.PayWith != 'other';
                                        else payWithOtherImg
                                      "
                                    />
                                    <ng-template #payWithOtherImg>
                                      <img
                                        src="assets/images/random_assets/pay_with_other_selected.png"
                                        class="invoice-icon"
                                        alt="pay_with_other_method icon"
                                      />
                                    </ng-template>
                                  </button>

                                  <button
                                    matTooltip="Signature"
                                    mat-icon-button
                                    class="mt10 openDialog"
                                    (click)="
                                      item.SignatureRequired =
                                        !item.SignatureRequired
                                    "
                                    [disabled]="item?.DeliveryPartnerID == 9"
                                  >
                                    <img
                                      src="assets/images/random_assets/signature_required.png"
                                      alt="signature_required icon"
                                      class="invoice-icon"
                                      [ngClass]="{'disabled-sign-icon' : item?.DeliveryPartnerID == 9}"
                                      *ngIf="
                                        item.SignatureRequired;
                                        else noSignatureRequired
                                      "
                                    />
                                    <ng-template #noSignatureRequired>
                                      <img
                                        src="assets/images/random_assets/signature_not_required.png"
                                        class="invoice-icon"
                                        [ngClass]="{'disabled-sign-icon' : item?.DeliveryPartnerID == 9}"
                                        alt="signature_not_required icon"
                                      />
                                    </ng-template>
                                  </button>

                                  <button
                                    class="mt10 openDialog"
                                    mat-button
                                    [matMenuTriggerFor]="moreOpt"
                                  >
                                    <span class="material-icons-outlined"
                                      >more_vert
                                    </span>
                                  </button>
                                  <mat-menu #moreOpt="matMenu">
                                    <button
                                      mat-menu-item
                                      class="d-flex align-items-center"
                                      (click)="
                                        modalService.addDimentionWeightDialog(
                                          item
                                        )
                                      "
                                    >
                                      Dimension/Weight
                                    </button>
                                    <button
                                      mat-menu-item
                                      class="d-flex align-items-center"
                                      (click)="openPromoCode(item)"
                                    >
                                      Promo Code
                                    </button>
                                  </mat-menu>
                                </td>
                                <td>
                                  <mat-slide-toggle
                                    color="primary"
                                    [checked]="ship(item)"
                                    (change)="shipChange($event, item)"
                                  >
                                  </mat-slide-toggle>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <app-pagination
                          [config]="config"
                          (pageChange)="pageChange($event)"
                          id="server"
                          *ngIf="!progress_spinner"
                        >
                        </app-pagination>
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-md-12">
                              <div
                                class="d-flex justify-content-center justify-content-md-end border-top pt-4"
                              >
                                <button
                                  class="custom-btn"
                                  (click)="openProcessPaymentDialog()"
                                  type="button"
                                  [disabled]="!isProcessPaymentEnable"
                                >
                                  Process Payment
                                </button>
                                <button
                                  class="custom-btn"
                                  type="button"
                                  [disabled]="isCheckRateEnable"
                                  (click)="onCheckRateClick()"
                                >
                                  Check Rate
                                  <span
                                    class="whiteLoader"
                                    *ngIf="isCheckRateLoading"
                                    >&nbsp;</span
                                  >
                                </button>
                                <button
                                  class="custom-btn"
                                  (click)="openProcessOrderModel()"
                                  type="button"
                                  [disabled]="!isProcessOrderEnable || isProcessOrderLoading"
                                >
                                  Process Order
                                  <span
                                    class="whiteLoader"
                                    *ngIf="isProcessOrderLoading"
                                    >&nbsp;</span
                                  >
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab label="Manual" [disabled]="progress_spinner">
                  <app-manual-order></app-manual-order>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #th let-key="key" let-value="value">
  <th (click)="sort(key)" class="position-relative">
    {{ value }}
    <span class="material-icons sort" *ngIf="paginationObj.sort_key == key">
      {{ paginationObj.sort_type == SortType.Ascending ? "south" : "north" }}
    </span>
  </th>
</ng-template>
